import html from "html-literal";
import Kodaq from "../../assets/images/Kodaq.png";
import BlackAuthorsExpo from "../../assets/images/BlackAuthorsExpo.png";
import TheCouplesPlaydate from "../../assets/images/TheCouplesPlaydate.jpg";
import ndblackauthors from "../../assets/images/ndblackauthors.jpg";
export default () => html`

<!-- <section class=events>
<h1>Upcoming Events</h1>
<img src=${BlackAuthorsExpo} alt="anxiety" width="400x400" /><br />
<p>KittyPinkCards will have Mothers's Day baskets and cards for sale as well as access to purchase PoeticPhotos</p>
</section> -->


<section class=poem>
      <h1><u>Poem of the Month</u></h1><br>
      <p class=week> <br>
      <br>

      Title:Black Man<br>
      <br>


I see you Black Man,<br>
all on the internet shaming women, I see you black man<br>
in every picture throwing gang signs, I see you Black Man,<br>
all in the streets killing each other, I see you Black Man,<br>
leaving your kids to fend for themselves, I see you black man<br>
Oh you to good to work, I see you black man<br>
we might as well kill you so we don’t see you black man,<br>
No, you want to kill me because you are afraid of this black man,<br>
all on the internet loving our black women as a black man,<br>
in every picture with our degrees as a black man,<br>
all in the streets rebuilding our community as a black man,<br>
showing up for our kids and cheering them on as a black man,<br>
taking over corporate America and having our businesses as a black man,<br>
you are afraid of that black man so u try to paint a negative picture for the world to see of a black man,<br>
we built this country and youre afraid of my power as a black man,<br>
everybody loves us and our culture so you envy the black man,<br>
to my black men—protect our women and keep raising our kids as a black man,<br>
walk tall and head high as a proud black man,<br>
Because theres no greater feeling than being a beautiful Black Man<br>
</p>

<h4>Poem by: Kodaq <br> Kodaq is an entrepreneur, curator, creator and brand developer who enjoys writing in his free time. Find him on Instagram by clicking the picture below
<br>
<a href="https://instagram.com/kodaq314?igshid=YmMyMTA2M2Y=" target="popup"><img src=${Kodaq} alt="anxiety" width="450x450" /><br /></a>
</h4>
<!--
<h4>If you liked this poem let the Poet know by commenting below!</h4>
<div id="comment"><input type="text" id="comment-box" placeholder="Enter comment">
    <button id="post">Post</button>
    <ul id="unordered">

   </ul>

    <script src="code.js"></script>
    </div> -->

    <h4 font size=18px>Want to feature your poem here?<br>
  Email us and include your poem, name, and contact information</h4>

  <h4>Past Events</h4>

<p>The Couples Playdate<br>
This was so much fun! Thecouplesplaydate.com for more info
<br>
<ul><a href="https://drive.google.com/drive/u/1/folders/16M64luy1Rw8EvI_s1tk-x-HFDnZAheQ7" target="popup">
    <img src=${TheCouplesPlaydate} alt="The Couples Playdate Event" width=400x400/>
   </ul></p><br>Click for event pictures<br></a>

   <p>Black Authors Expo 2022<br>
  There were so many great Authors in the room<br>
<u;><a href="https://drive.google.com/drive/folders/1eGr0A6-ZMmdMfJ1yRHw4XCUU5Pfoh3JI?usp=sharing" target="popup"></u></h1>
<img src=${BlackAuthorsExpo} alt="Black Authors Expo 22" width=400x400/><br>Click for event pictures<br></a>
   </p>

   <p>Black Authors Expo Spring 2023<br>
  Back Again<br>
<u;><a href="https://drive.google.com/drive/folders/12Cn7LgwzTDzGqORIZ7xNTVtVkhP2JdHE" target="popup"></u></h1>
<img src=${ndblackauthors} alt="Black Authors Expo 2023" width=400x400/><br>Click for event pictures<br></a>
   </p>
  </section>
    <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
  </section>
`;
